import { State } from 'store';

export const Selectors = {
  hasInitialised: (state: State): boolean => state.data.launchDarkly && state.data.launchDarkly.initialised,
  keyExists: (state: State, key: string): boolean =>
    state.data.launchDarkly && state.data.launchDarkly.keys && !!state.data.launchDarkly.keys[key],
  keyIsInProgress: (state: State, key: string): boolean =>
    state.data.launchDarkly &&
    state.data.launchDarkly.keys &&
    state.data.launchDarkly.keys[key] &&
    state.data.launchDarkly.keys[key].inProgress,
  keyIsAllowed: (state: State, key: string): boolean =>
    state.data.launchDarkly &&
    state.data.launchDarkly.keys &&
    state.data.launchDarkly.keys[key] &&
    state.data.launchDarkly.keys[key].allowed,
};
